'use client'

import { use } from 'react'

import { useAuthContext } from '@/context/AuthContext'
import { CheckEnterRoomContext } from '@/context/CheckEnterRoomContext'
import { enableGoogleAd, isAdFreeWorld } from '@/lib/configs'

export type AdFreeReason =
  | 'google-ad-disabled'
  | 'game-plus'
  | 'ad-free-genre-tag'
  | 'owner-only-room'
  | 'preview-access'
  | 'viverse-pro-owner'

type PlatformAdFree = {
  isAdFree: boolean
  adFreeReason: AdFreeReason | null
}

export const usePlatformAdFree = (): PlatformAdFree => {
  const { isGamePlus } = useAuthContext()
  const roomContext = use(CheckEnterRoomContext)

  const adFreeRules: { isMatch: boolean; reason: AdFreeReason }[] = [
    { isMatch: !enableGoogleAd(), reason: 'google-ad-disabled' },
    { isMatch: isGamePlus, reason: 'game-plus' },
    {
      isMatch: isAdFreeWorld(roomContext?.roomData.tags ?? []),
      reason: 'ad-free-genre-tag',
    },
    {
      isMatch: roomContext?.roomData.policy === 'owner_only',
      reason: 'owner-only-room',
    },
    { isMatch: roomContext?.canPreview === true, reason: 'preview-access' },
    {
      isMatch: roomContext?.roomData.owner?.viverse_pro === true,
      reason: 'viverse-pro-owner',
    },
  ]

  const matchingRule = adFreeRules.find(({ isMatch }) => isMatch)

  return matchingRule
    ? { isAdFree: true, adFreeReason: matchingRule.reason }
    : { isAdFree: false, adFreeReason: null }
}
